<a class="logo" routerLink="/">
  <img class="logo__image" src="assets/images/logo.svg" width="74" height="48" alt="Logo">
</a>
